import { createRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { siteKey } from "../Utils";
import RegisterModal from "../components/RegisterModalPhantom";
import "../styles/home.css";

function HomePhantom() {
  const recaptchaRef = createRef();
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  document.body.id = "home";

  // as soon as page mounts
  useEffect(() => {
    setIsRegisterOpen(true); // register a phantom user
  }, []);

  return (
    <>
      <RegisterModal state={[isRegisterOpen, setIsRegisterOpen]} />
      {createPortal(
        <ReCAPTCHA ref={recaptchaRef} sitekey={siteKey} size="invisible" />,
        document.body,
      )}
    </>
  );
}

export default HomePhantom;
